import { Injectable, Output, EventEmitter } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SweetAlertService {

  @Output() confirmation: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();

  constructor() { }

  swalInfo(message: string): void {
    Swal.fire(message);
  }

  swalError1(texto): void {
    Swal.fire({
      type: 'error',
      title: 'Ups...',
      text: texto,
      confirmButtonColor: '#36ABAC'
    });
  }

  swalError(): void {
    Swal.fire({
      type: 'error',
      title: 'Ups...',
      text: '¡Algo salió mal!',
      confirmButtonColor: '#36ABAC'
    });
  }

  swalConfirmDialog(data): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: '¡No podrás revertir esto!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#36ABAC',
      cancelButtonColor: '#E06162',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si, eliminar'
    }).then((result) => {
      if (result.value) {
        this.confirmation.emit(data);
      }
    });
  }

  swalNewTransaction(data): void {
    Swal.fire({
      imageUrl: 'assets/img/alert.png',
      title: '<h1 class="text-blue mb-5 mt-5 display-3 bold">¿Deseas realizar una<br> nueva transacción?</h1>',
      showCancelButton: true,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-nueva btn-blue shadow-sm',
        cancelButton: 'btn-nueva btn-white mt-5 shadow-sm',
        image: 'alert-img mb-5',
        actions: 'col-11 offset-2',
        container: 'new'
      },
      confirmButtonText: '<h1>SI</h1>',
      cancelButtonText: '<h1>NO</h1>',
      position: 'bottom-start',

      padding: '8em',
      width: '100%',
      allowOutsideClick: false
    }).then((result) => {
      if (result.value) {
        this.confirmation.emit(data);
      } else {
        this.cancel.emit(data);
      }
    });
  }

  swalPrint(): void {
    Swal.fire({
      imageUrl: 'assets/img/print.gif',
      imageAlt: 'Imprimiendo',
      imageHeight: 230,
      imageWidth: 215,
      // title: 'Imprimiendo',
      // width: '100%',
      position: 'center',
      showConfirmButton: false,
      allowOutsideClick: false,
    });
  }

  swalLoading(): void {
    const html = '<div><img src="assets/img/loading.gif"></div>';
    Swal.fire({
      html,
      position: 'center',
      showConfirmButton: false,
      background: 'bottom',
      backdrop: 'rgba(255,255,255,0.4)',
      allowOutsideClick: false,
      customClass: {
        title: 'spinner-border'
      }
    });
  }

  swalErrorPromise(message: string): Promise<any> {
    return Swal.fire({
      type: 'error',
      title: '¡Algo salió mal!',
      text: message,
      confirmButtonColor: '#36ABAC'
    });
  }

  swalToolsAlert(text: string, titulo: any, tipo: any) {
    Swal.fire({
      type: tipo,
      title: titulo,
      text,
      confirmButtonColor: '#0079c8',
      allowOutsideClick: false,
      customClass: {
        popup: 'swal2-modal-content swal2-modal-alert',
        confirmButton: 'swal2-btn-gral',
        content: 'swal2-text-grey bold'
      }
    });
  }

  async swalToolConfirmation(titulo: any, tipo: any, accion: any): Promise<any> {
    let response = false;

    await Swal.fire({
      title: titulo,
      text: `¿Está seguro de ${ accion } el equipo?`,
      type: tipo,
      showCancelButton: true,
      confirmButtonColor: '#0079c8',
      cancelButtonColor: '#dE06162',
      confirmButtonText: `Sí, ${ accion }`,
      cancelButtonText: 'No',
      allowOutsideClick: false,
      customClass: {
        popup: 'swal2-modal-content swal2-modal-alert',
        confirmButton: 'swal2-btn-gral',
        cancelButton: 'swal2-btn-gral',
        content: 'swal2-text-grey bold'
      },
    }).then((result) => {
      if (result.value) {
        response = true;
      }
    });

    return response;
  }

  swalClose(): void {
    Swal.close();
  }
}
